import React, { useState } from 'react';
import styled from 'styled-components';
import { CommonStyles } from '../BasicDetails/BasicDetails';
import frameIcon from '../../../images/frame.png';
import angleRightIcon from '../../../images/angle_right.png';
import { NextButton } from '../OnboardingPage';
import { useOnboarding } from '../../../contexts/OnboardingContext';
import { logger } from '../../../utils/logger';
const KYCList = () => {
  const {
    setCurrScreen,
    handleSteps,
    detailsFlow,
    stepsInfo,
    currStep,
    setPrevPage,
  } = useOnboarding();
  logger.log(
    'kyclist',
    detailsFlow,
    currStep,
    currStep.component !== 'ReviewKYCDetails'
  );
  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    let isLastStep = true;
    if (isLastStep) {
      setCurrScreen('review');
    } else {
      setCurrScreen('landing');
    }

    handleSteps('ReviewKYCDetails');
  };
  return (
    <Wrapper className="flex-wrapper">
      <KYCWrapper>
        <div className="form-steps" id="step-1">
          <div className="steps-header">
            <h5>
              <img src={frameIcon} alt="frame" /> It'll only take 5 mins
            </h5>
            <h3>Complete Your KYC</h3>
            <p className="sub-heading">
              KYC verification is mandatory for all financial transactions, as
              per Reserve Bank of India guidelines.
            </p>
          </div>

          <ul className="kyc-list">
            {detailsFlow.map((item, index) => {
              const isFinished = item.order < currStep.order;
              logger.log('item.component', item.component);
              if (
                item.component !== 'ReviewKYCDetails' &&
                item.component !== 'VerifyPAN'
              ) {
                return (
                  <li
                    key={index}
                    onClick={() => {
                      handleSteps(item.component);
                      setCurrScreen('');
                      setPrevPage('kyclist');
                    }}
                    className={`kyc row ${
                      item.order === currStep.order ? 'active' : ''
                    } ${item.order > currStep.order ? 'disabled' : ''} `}
                  >
                    <div>
                      <div className="kyc-left">
                        <img
                          src={require(`../../../images/kyc/${
                            isFinished ? 'Done' : item.component
                          }.png`)}
                          alt={item.title}
                        />
                        <div>
                          <h4>{item.title}</h4>
                          {item.subTitle && <p>{item.subTitle}</p>}
                        </div>
                      </div>
                      <button className="right-btn">
                        <img src={angleRightIcon} alt="angle right" />
                      </button>
                    </div>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      </KYCWrapper>
      <NextButton
        onClick={handleSubmit}
        // error={error}
        loading={loading}
        disabled={loading || currStep.component !== 'ReviewKYCDetails'}
      >
        Save & continue
      </NextButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  @media all and (max-width: 768px) {
    margin-top: -60px;
  }
`;

const KYCWrapper = styled.div`
  ${CommonStyles}

  .steps-header {
    margin-bottom: 32px;

    h5 {
      color: #ff6b00;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 16px;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .sub-heading {
      color: #666;
      font-size: 14px;
      margin-top: 8px;
    }
  }

  .kyc-list {
    margin: 10px 0 0;
    padding-left: 0;
    li {
      display: block;
      margin-bottom: 10px;
      cursor: pointer;
      &.disabled {
        pointer-events: none;
        opacity: 0.8;
        filter: grayscale(100);
      }
      &.finished {
      }

      > div {
        min-height: 56px;
        display: flex;
        border: 1px solid #dfe1e6;
        border-radius: 16px;
        padding: 0 12px;
        justify-content: space-between;
        align-items: center;
        gap: 0 10px;

        .kyc-left {
          align-items: center;
          display: flex;
          gap: 8px 14px;

          img {
            width: 24px;
            height: 24px;
            object-fit: contain;
          }
        }

        h4 {
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          margin: 0;
        }

        p {
          font-weight: 500;
          color: #253858;
          font-size: 12px;
          opacity: 60%;
          margin: 0;
        }

        .right-btn {
          border: none;
          background-color: transparent;
          cursor: pointer;
          padding: 8px;
          min-width: auto;
          width: auto;

          img {
            width: 20px;
            height: 14px;
            object-fit: contain;
          }
        }
      }
    }
  }

  .submit-btn {
    margin-top: 24px;
    background: #4c6fff;
  }
  @media all and (max-width: 768px) {
    .kyc-list {
      padding-left: 0;
    }
  }
`;

export default KYCList;
